import React from "react";
import { Button, Tooltip } from "antd";
import { ShareAltOutlined } from "@ant-design/icons";

export type ShareMatterButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const ShareMatterButton: React.FC<ShareMatterButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  const button = (
    <Button
      icon={<ShareAltOutlined />}
      type="primary"
      size="small"
      onClick={onClick}
      disabled={disabled}
    >
      Share
    </Button>
  );

  return (
    <>
      {disabled ? (
        <Tooltip title="Confidential matters can only be shared by their creator.">
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </>
  );
};
